module.exports = __webpack_public_path__ + "img/5.99d851f3.png";